<template>
  <div class="main-view trees-container">
		<div class="bg-container trees-hero">
			<div class="template-inner flex-row">
				<div class="one-half flex-row justify-center">
					<h1 class="hero-header">Helping solve<br> the world&#39;s most<br> urgent{{'\xa0'}}crisis</h1>
				</div>
				<div class="hero-silhouette one-half">
					<img src="@/assets/img/silhouettes/trees-silhouette-1.png" alt="" class="desktop-trees">
					<img src="@/assets/img/silhouettes/mobile-trees-silhouette.png" alt="" class="mobile-trees">
				</div>
			</div>
			<bg-wave-element></bg-wave-element>
		</div>
		<section class="tress-content-container">
			<!-- TREES PLANTED STARTS HERE -->
			<!-- <div class="trees-planted">
				<div class="trees-planted-icon">
					<img src="@/assets/img/icons/trees/white-tree.svg" alt="Tree icon">
				</div>
				<p class="number-of-trees-planted">49,872,590</p>
				<p><span>Trees Planted</span></p>
				<p>Every completed Evergrow action funds at least 5 new trees</p>
			</div> -->

			<div class="one-half count-box flex-col trees-planted">
				<div class="header-icon-container trees"></div>
				<p class="count" v-if="interval">{{ interval.community | numeral('0,0') }}</p>
				<p class="count" v-else>.....</p>
				<p class="count-description green">Trees Planted</p>
				<p class="count-tiny">Every completed Evergrow action funds at least 5 new trees</p>
			</div>
			<div class="template-inner trees-info inner-width">
				<p>With climate change impacting every business, and on every employee’s mind, Evergrow has created an innovative new funding model that directly connects employee action to tree planting and forest conservation. Give a colleague an award, redeem points for a reward, achieve a wellness goal… every action funds a new tree on a member’s dashboard. And when a member gets a new tree, the planet gets one too - as we fund one of our environmental partners to plant a tree for Evergrow.</p>
			</div>
			<!-- TREES PLANTED STARTS HERE -->

			<!-- 5 MILLION TREES STARTS HERE -->
			<div class="million-section-container">
				<div class="million-section-inner template-inner">
					<div class="left-half">
						<img class="millions-top-img" src="@/assets/img/features/million-left-size-img.png" alt="">
						<img class="millions-bottom-img" src="@/assets/img/features/planting-hands.png" alt="">
					</div>
					<div class="right-half">
						<div class="sectioning-container">
							<h2>5 million trees – 365{{'\xa0'}}days</h2>
							<p>Evergrow is committed to planting 5 million trees in our first year. All of the projects launched by Evergrow and our environmental partners will be audited and published in our community accountability report.</p>
						</div>
						<div class="million-section-logos">
							<img src="@/assets/img/logos/eden-project.png" alt="" class="million-logo eden">
							<!-- <img src="@/assets/img/logos/nature-conservancy.png" alt="" class="million-logo nature"> -->
							<img src="@/assets/img/logos/sierra-club.png" alt="" class="million-logo sierra">
						</div>
					</div>
				</div>
			</div>
			<!-- 5 MILLION TREES ENDS HERE -->

			<!-- PLANTING GROWS STARTS HERE -->
			<div class="planting-grows">
				<div class="template-inner flex-row">
					<div class="one-half left">
					<h2>Planting grows the entire community</h2>
						<p>Recent science shows that one effective way to reduce greenhouse gas is to plant more trees and restore vital forests. We partner directly with tree planting organizations, like Eden Reforestation Projects, to plant and sustain healthy forests around the globe. We’re intentionally designing each project to create grassroots rewards. Funding from every project enriches every local community as residents are employed and fairly paid to plant and nurture native trees. Local projects create local jobs, which creates sustainable development and growth where it’s most needed.</p>
					</div>
					<div class="one-half right">
						<img src="@/assets/img/silhouettes/trees-silhouette-2.png" alt="">
					</div>
				</div>
					<bg-wave-element></bg-wave-element>
			</div>
			<!-- PLANTING GROWA ENDS HERE -->
			<!-- OUR PROJECTS STARTS HERE -->
			<div class="our-projects template-inner">
				<div class="flex-col">
					<h2>Our Projects</h2>
					<p class="projects-content inner-width">We partner directly with tree planting organizations, like Eden Reforestation Projects, to plant and sustain healthy forests around the globe. Local projects create local jobs, which creates sustainable development and growth where it’s most needed.</p>
					<div class="flex-row project-row top-row">
						<div class="project-box">
							<p class="project-location">Nepal</p>
							<img class="project-img" src="@/assets/img/features/Nepal.png" alt="">
						</div>
						<div class="project-box">
							<p class="project-location">Madagascar</p>
							<img class="project-img" src="@/assets/img/features/Madagascar.png" alt="">
						</div>
						<div class="project-box">
							<p class="project-location">Haiti</p>
							<img class="project-img" src="@/assets/img/features/Haiti.png" alt="">
						</div>
					</div>
					<div class="flex-row project-row bottom-row">
						<div class="project-box">
							<p class="project-location">Indonesia</p>
							<img class="project-img" src="@/assets/img/features/Indonesia.png" alt="">
						</div>
						<div class="project-box">
							<p class="project-location">Mozambique</p>
							<img class="project-img" src="@/assets/img/features/Mozambique.png" alt="">
						</div>
						<div class="project-box">
							<p class="project-location">Kenya</p>
							<img class="project-img" src="@/assets/img/features/Kenya.png" alt="">
						</div>
					</div>
				</div>
			</div>
			<!-- OUR PROJECTS ENDS HERE -->
			<section class="rewards-info-container trees">
				<div class="stroke"></div>
				<div class='rewards-info-inner trees align-center'>
					<img class="rewards-star-icon" src="@/assets/img/icons/rewards/yellow-star.svg" alt="star icon">
					<p>There are many ways a member can get recognized and help plant a thriving forest.</p>
					<!-- <button class="rewards-button">Learn more</button> -->
					<button class="rewards-button" @click="$router.push('/features/recognition')">Learn{{'\xa0'}}more</button>
				</div>
				<div class="stroke"></div>
			</section>
		</section>
		<Demo />
  </div>
</template>

<script>
	/* eslint-disable */
	
	import Demo from "../components/Demo";

	export default {
		name: 'Features-Trees',
		data() {
			return {
				interval: []
			}
		},
		methods: {
			fetchTreeCount: function () {
			  const baseURI = 'https://api-ms.p2motivate.com/evergrow-trees/trees/funded'
			  this.$http.get(baseURI)
			  .then((result) => {
			    this.interval = result.data
			  })
			}
		},
		created () {
			this.fetchTreeCount()
			this.interval = setInterval(() => this.fetchTreeCount(), 30000);
		},
		components: {
			Demo
		}
	}
</script>

<style lang="stylus" scoped>

	.bg-container.trees-hero 
		background url('~@/assets/img/bgs/sub-page-hero-bg.svg') center center / cover no-repeat #fff
		display flex
		flex-direction column
		justify-content space-between
		
		.template-inner
			padding-top 140px
			margin-bottom 40px


	.hero-silhouette.one-half 
		display flex
		align-items flex-end
		align-self flex-end

		img
			position relative
			width 100%
		
		.mobile-trees
			display none

// //----- TREES PLANTED ----- 
	.trees-planted 
		box-shadow 0px 40px 80px #00000033
		background white
		width 90% !important
		max-width	700px
		text-align center
		margin 0 auto 
		border-radius 40px
		padding 20px 50px 50px
		position relative
		z-index 3
		top -220px
		
	.count-tiny
		font-size 14px  !important
		line-height 20px
		// min-height 60px

// 	.trees-planted p
// 		font-size 12px


// 	.trees-planted .number-of-trees-planted
// 		font-size 50px
// 		margin-bottom -8px
	
// 	.trees-planted span 
// 		color #00A562
// 		font-size  30px
// 		display inline-block
// 		margin-bottom 18px

// 	.trees-planted-icon
// 		background #00a562
// 		padding 20px 18px 15px 18px
// 		display inline-block
// 		border-radius 50%
// 		margin-top -40px
// 		margin-bottom 14px
// 		img
// 			width 50px
// 			height 45px
	
	.trees-info p 
		text-align center
		margin -103px auto 70px

	//----- MILLION TREES SECTION ----- 
	.tress-content-container
		margin 0 auto 100px auto

	h2
		font-size 45px
		padding-top 30px

	.million-section-container
		margin 80px 0 240px

	.million-section-inner
		display flex
		justify-content space-between
		align-items center

	.left-half
		position relative
		width 45%
		
	.right-half
		width 48%
		
		h2
			text-align left
			
		p
			padding 20px 0

	.millions-top-img 
		width 86%

	.millions-bottom-img
		width  200px
		position absolute
		right 8%
		bottom -10%
		border-radius 100%
		box-shadow 0px 40px 80px #00000033

	.million-section-logos
		display flex
		flex-wrap wrap 
		align-items center
		justify-content space-between
		width 88%
		padding 20px
		.eden 
			width  250px
		.sierra,
		.nature
			width 170px

	.million-section-logos img
		padding 20px 0


//----- PLANTING GROWS ----- 
	.planting-grows
		background url('~@/assets/img/bgs/trees-planting-bg.svg') center center / cover no-repeat #fff
		padding-bottom 164px
		.template-inner
			h2
				text-align left
				padding-top 0
				margin-top -70px
			.right img 
				width 100%
				margin-top -56px
			.left 
				margin-top -150px
				p
					padding-top 20px



	//----- OUR PROJECTS ----- 

	h2
		text-align center
	.our-projects 
		margin-top -100px
		z-index 2
	
	.projects-content
		text-align center
		margin-bottom 30px
	
	.project-row.top-row
		margin-bottom 40px

	p.project-location { font-size: 24px; }

	.project-row {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}
	.project-row .project-box {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		// opacity: 0;
		padding: 0 40px
	}
	.project-row img {
		width: 75%;
		margin-bottom: 20px;
		box-shadow: 0px 20px 40px #00000033;
		border-radius: 100%;
	}
	.project-row.animated-row .project-box:nth-of-type(1) { animation: fade-in 0.5s ease-in-out 0s forwards !important; }
	.project-row.animated-row .project-box:nth-of-type(2) { animation: fade-in 0.5s ease-in-out 0.3s forwards !important; }
	.project-row.animated-row .project-box:nth-of-type(3) { animation: fade-in 0.5s ease-in-out 0.6s forwards !important; }

	//----- REWARDS INFO ----- 
	.rewards-info-container.trees 
		margin-bottom 160px

	/*ANIMATIONS*/
	@keyframes fade-in {
		from { opacity: 0; }
		to { opacity: 1; }
	}

	@keyframes pop-in {
		from {
			opacity: 0;
			transform: scale(.95);
		}
		to {
			opacity: 1;
			transform: scale(1);
		}
	}
	
	@media (max-width: 1230px) and (min-width: 1001px)
		.trees-hero .template-inner.flex-row
			margin-bottom 80px
			
		.trees-hero .one-half.flex-row.justify-center h1.hero-header
			font-size 65px !important
	
	@media (max-width: 1000px)
		.trees-hero
			padding-top 180px
			
			.flex-row
				flex-direction column
				padding-top 0 !important
			
			
			.one-half
				width 100% !important
				
				.desktop-trees
					display none
				
				.mobile-trees
					display block
					width 80%
					margin 0 auto
				
			.hero-header
				font-size 52px
				text-align center
				margin-bottom 80px
				
				& br
					display none
				
		.trees-container svg
			display none
			
		.trees-planted
			width 80%
			top -40px
			margin-botom 200px
			
		.trees-info p
			margin 80px 0 0 0

		.template-inner .trees-info
			margin-top 170px
			
		.million-section-container
			margin-bottom 90px
			
		.million-section-inner
			flex-direction column
			width 100%
			
			.left-half
				width 55%
				margin-bottom 60px
			
			.millions-top-img
				width 90%
				
			.millions-bottom-img
				width 52%
				right 2%
				bottom -8%
				left unset
				top unset
				
			.right-half
				width 80%
				margin 0 auto
				
		.right-half .sectioning-container
			width 80%
			margin 0 auto
		
		.million-section-logos
			margin 0 auto
			flex-direction column
			padding 0
			
			img 
				width 70% !important
				padding 30px 0 10px 0
				
				&:last-of-type
					width 55% !important
					
		.planting-grows
			background-image none
			background-color #00A5621A
			padding-bottom 0
			
			.flex-row
				flex-direction column
				
				.one-half 
					width 100% !important
					
					&.left
						margin-top 60px
						
						h2
							margin-top 0
							
						p
							margin-bottom 60px
							
					&.right
						display flex

						img
							margin 0 auto
							width 80% !important
							
							
		.our-projects
			margin-top 60px		
			
		.projects-content.inner-width
			width 100%
			margin-bottom 80px
			
		.flex-row.project-row	
			flex-direction column
			margin-bottom 0
			
			.project-box
				margin-bottom 60px
				padding 0
				
				img 
					width 100%
					
		.rewards-info-container.trees
			margin-top 80px
			
			.stroke
				display none

</style>